import { render, staticRenderFns } from "./frigoHours.vue?vue&type=template&id=3fc138cb&scoped=true&"
import script from "./frigoHours.vue?vue&type=script&lang=js&"
export * from "./frigoHours.vue?vue&type=script&lang=js&"
import style0 from "./frigoHours.vue?vue&type=style&index=0&id=3fc138cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc138cb",
  null
  
)

export default component.exports